<ul class="breadcrumbs" *ngIf="parents.length>1">
  <li *ngFor="let parent of parents"><a [routerLink]="parent.link">{{parent.name}}</a></li>
  <li>{{page.name}}</li>
</ul>